export function StatCard({ label, value, sublabel, icon: Icon, accent, bg, index }) {
  return (
    <div
      className="rounded-2xl p-5 flex justify-between gap-3 animate-fade-in-up"
      style={{
        background: "#FFFFFF",
        border: `1px solid ${bg}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        animationDelay: `${index * 0.06}s`,
      }}
    >
      <div>
        <p className="text-[20px] font-black leading-none mb-1" style={{ color: accent, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
          {value}
        </p>
        <p className="text-[12px] font-bold text-slate-600">{label}</p>
        {sublabel && <p className="text-[11px] text-slate-400 mt-0.5">{sublabel}</p>}
      </div>
      <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: bg }}>
        <Icon size={18} style={{ color: accent }} />
      </div>
    </div>
  );
}